import i18n from "../i18n";
import * as rk from "../localization/resourceKeys";

export const provinces = [
  {
    name: i18n.t(rk.STATES.ALBERTA),
    abbreviation: "AB",
  },
  {
    name: i18n.t(rk.STATES.BRITISH_COLUMBIA),
    abbreviation: "BC",
  },
  {
    name: i18n.t(rk.STATES.MANITOBA),
    abbreviation: "MB"
  },
  {
    name: i18n.t(rk.STATES.NEW_BRUNNSWICK),
    abbreviation: "NB", 
  },
  {
    name: i18n.t(rk.STATES.NEWFOUNDLAND_AND_LABRADOR),
    abbreviation: "NL",
  },
  {
    name: i18n.t(rk.STATES.NOVA_SCOTIA),
    abbreviation: "NS",
  },
  {
    name: i18n.t(rk.STATES.NUNAVUT),
    abbreviation: "NU",
  },
  {
    name: i18n.t(rk.STATES.NORTHWEST_TERRITORIES),
    abbreviation: "NT",
  },
  {
    name: i18n.t(rk.STATES.ONTARIO),
    abbreviation: "ON", 
  },
  {
    name: i18n.t(rk.STATES.PRINCE_EDWARD_AND_ISLAND),
    abbreviation: "PE",
  },
    {
    name: i18n.t(rk.STATES.QUEBEC),
    abbreviation: "QC",
  },
  {
    name: i18n.t(rk.STATES.SASKATCHEWAN),
    abbreviation: "SK",
  },
  {
    name: i18n.t(rk.STATES.YUKON),
    abbreviation: "YT",
  },
]

export const provincesInFrench = [
  {
    name: i18n.t(rk.STATES_FR.ALBERTA),
    abbreviation: "AB",
  },
  {
    name: i18n.t(rk.STATES_FR.BRITISH_COLUMBIA),
    abbreviation: "BC",
  },
  {
    name: i18n.t(rk.STATES_FR.MANITOBA),
    abbreviation: "MB"
  },
  {
    name: i18n.t(rk.STATES_FR.NEW_BRUNNSWICK),
    abbreviation: "NB", 
  },
  {
    name: i18n.t(rk.STATES_FR.NEWFOUNDLAND_AND_LABRADOR),
    abbreviation: "NL",
  },
  {
    name: i18n.t(rk.STATES_FR.NOVA_SCOTIA),
    abbreviation: "NS",
  },
  {
    name: i18n.t(rk.STATES_FR.NUNAVUT),
    abbreviation: "NU",
  },
  {
    name: i18n.t(rk.STATES_FR.NORTHWEST_TERRITORIES),
    abbreviation: "NT",
  },
  {
    name: i18n.t(rk.STATES_FR.ONTARIO),
    abbreviation: "ON", 
  },
  {
    name: i18n.t(rk.STATES_FR.PRINCE_EDWARD_AND_ISLAND),
    abbreviation: "PE",
  },
    {
    name: i18n.t(rk.STATES_FR.QUEBEC),
    abbreviation: "QC",
  },
  {
    name: i18n.t(rk.STATES_FR.SASKATCHEWAN),
    abbreviation: "SK",
  },
  {
    name: i18n.t(rk.STATES_FR.YUKON),
    abbreviation: "YT",
  },
]


export const supportedProvinces = ['QC'];